<template>
    <div class="between flex w-full border">
        <fieldset class="mb-4 flex w-full flex-col px-4 py-2">
            <h3 class="mt-4 text-content-lg">
                <small class="text-content-lg">xs / 0.75rem / 12px</small>
            </h3>
            <DsSpinner size="xs" />
            <h3 class="mt-4 text-content-lg">
                <small class="text-content-lg">sm / 1rem / 16px</small>
            </h3>
            <DsSpinner size="sm" />
            <h3 class="mb-3 mt-4 text-content-lg">
                <small class="text-content-lg">md / 1.5rem / 24px</small>
            </h3>
            <DsSpinner size="md" />
            <h3 class="mb-3 mt-4 text-content-lg">
                <small class="text-content-lg">lg / 2rem / 32px</small>
            </h3>
            <DsSpinner size="lg" />
            <h3 class="mb-3 mt-4 text-content-lg">
                <small class="text-content-lg">xl / 2.5rem / 40px</small>
            </h3>
            <DsSpinner size="xl" />
            <h3 class="mb-3 mt-4 text-content-lg">
                <small class="text-content-lg">xxl / 3rem / 48px</small>
            </h3>
            <DsSpinner size="xxl" />
            <h3 class="mb-3 mt-4 text-content-lg">With slots and classes</h3>
            <DsSpinner
                class="flex w-32 flex-col items-center justify-center p-4"
                size="xl"
                sr-text="Loading with custom text..."
            >
                <template #before>
                    <h4 class="text-content-lg">Loading...</h4>
                </template>
                <template #after>
                    <p class="text-content-sm">Please wait</p>
                </template>
            </DsSpinner>
            <h3 class="mb-3 mt-4 text-content-lg">Page loading</h3>
            <DsSpinner
                centerIcon="fak fa-cl-logo"
                centerIconSize="xl"
                size="xxxl"
                variant="brand"
            />
        </fieldset>
        <fieldset class="mb-4 flex w-full flex-col px-4 py-2">
            <h3 class="mt-4 text-content-lg">
                <small class="text-content-lg">Primary</small>
            </h3>
            <DsSpinner
                size="xxl"
                variant="primary"
            />
            <h3 class="mt-4 text-content-lg">
                <small
                    class="text-content-lg"
                    size="xxl"
                >
                    Secondary
                </small>
            </h3>
            <DsSpinner
                size="xxl"
                variant="secondary"
            />
            <h3 class="mb-3 mt-4 text-content-lg">
                <small class="text-content-lg">Destructive</small>
            </h3>
            <DsSpinner
                size="xxl"
                variant="destructive"
            />
            <h3 class="mb-3 mt-4 text-content-lg">
                <small class="text-content-lg">Branded</small>
            </h3>
            <DsSpinner
                centerIcon="fak fa-cl-logo"
                centerIconSize="md"
                size="xxl"
                variant="brand"
            />
            <h3 class="mb-3 mt-4 text-content-lg">
                <small class="text-content-lg">Inverse</small>
            </h3>
            <div class="flex w-fit rounded-md bg-ds-primary-800 p-4">
                <DsSpinner
                    size="xxl"
                    variant="inverse"
                />
            </div>
        </fieldset>
    </div>
</template>

<script setup lang="ts">
import DsSpinner from '@/components/design-system/spinner/DsSpinner.vue';
</script>

<style scoped lang="scss">
h2,
h3 {
    @apply my-4;
}
</style>
